import { Navigate } from "react-router-dom";
import { normalizeUser } from "../utils/user";
import { normalizeRole } from "../utils/roles";

export default function RoleRedirect() {
  const storedUser = localStorage.getItem("user");

  let user = null;
  try {
    user = storedUser ? normalizeUser(JSON.parse(storedUser)) : null;
  } catch (error) {
    console.error("Error parsing user:", error);
  }

  const role = normalizeRole(user?.role);

  if (!user || !role) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }

  switch (role) {
    case "ADMIN":
      return <Navigate to="/admin" replace />;
    case "SUPERVISOR":
      return <Navigate to="/home" replace />;
    case "OPERATOR":
      return <Navigate to="/operator" replace />;
    default:
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return <Navigate to="/login" replace />;
  }
}
